(function () {
  /* ---------- Mobile nav ---------- */
  const burger = document.querySelector('.site-header__burger');
  const nav = document.getElementById('MobileNav');
  if (burger && nav) {
    const setOpen = (open) => {
      burger.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      document.body.classList.toggle('mobile-nav-open', open);
    };
    burger.addEventListener('click', () => {
      const open = burger.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
    });
    nav.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') setOpen(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') setOpen(false);
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerScrim = document.querySelector('.cart-drawer__scrim');
  const drawerBody = document.querySelector('[data-cart-body]');
  const cartCountEl = document.querySelector('[data-cart-count]');

  const openCart = () => {
    if (!drawer || !drawerScrim) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    drawerScrim.hidden = false;
    requestAnimationFrame(() => drawerScrim.classList.add('is-open'));
    document.body.classList.add('cart-drawer-open');
    setTimeout(() => drawer.focus(), 50);
  };
  const closeCart = () => {
    if (!drawer || !drawerScrim) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    drawerScrim.classList.remove('is-open');
    setTimeout(() => { drawerScrim.hidden = true; }, 280);
    document.body.classList.remove('cart-drawer-open');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });

  const updateCartCount = (count) => {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    if (count > 0) cartCountEl.removeAttribute('hidden');
    else cartCountEl.setAttribute('hidden', '');
  };

  const refreshDrawer = async () => {
    try {
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer-fragment`, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      if (!res.ok) throw new Error(`Drawer refresh failed: HTTP ${res.status}`);
      const data = await res.json();
      const html = data['cart-drawer-fragment'];
      if (drawerBody && html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inner = doc.querySelector('[id^="shopify-section-"]') || doc.body;
        drawerBody.innerHTML = inner.innerHTML;
      }
      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
      }
    } catch (err) { console.error('[cart] refreshDrawer failed:', err); }
  };

  const postCartAdd = async (form) => {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of formData) params.append(k, typeof v === 'string' ? v : '');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: params.toString(),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = body.description || body.message || `Could not add to cart (HTTP ${res.status})`;
      console.error('[cart] /cart/add.js error:', body);
      throw new Error(msg);
    }
    return body;
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const addButton = form.querySelector('[data-add-button]');
    if (addButton) addButton.disabled = true;
    try {
      await postCartAdd(form);
      await refreshDrawer();
      openCart();
    } catch (err) {
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      if (addButton) addButton.disabled = false;
    }
  });

  document.addEventListener('click', async (e) => {
    const buyBtn = e.target.closest('[data-buy-now]');
    if (buyBtn) {
      const form = buyBtn.closest('form');
      if (!form) return;
      e.preventDefault();
      buyBtn.disabled = true;
      buyBtn.dataset.label = buyBtn.dataset.label || buyBtn.textContent;
      buyBtn.textContent = 'Redirecting…';
      try {
        await postCartAdd(form);
        window.location.href = '/checkout';
      } catch (err) {
        alert(err.message || 'Something went wrong. Please try again.');
        buyBtn.disabled = false;
        buyBtn.textContent = buyBtn.dataset.label;
      }
      return;
    }

    const changeBtn = e.target.closest('[data-cart-change]');
    if (!changeBtn) return;
    const key = changeBtn.getAttribute('data-cart-change');
    const qty = changeBtn.getAttribute('data-qty');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(qty) }),
      });
      if (!res.ok) throw new Error(`Cart update failed: HTTP ${res.status}`);
      await refreshDrawer();
    } catch (err) { console.error('[cart] change failed:', err); }
  });

  /* ---------- Predictive search overlay ---------- */
  const overlay = document.querySelector('[data-search-overlay]');
  const overlayScrim = document.querySelector('.search-overlay__scrim');
  const searchInput = document.querySelector('[data-search-input]');
  const resultsBox = document.querySelector('[data-search-results]');

  const openSearch = () => {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    if (overlayScrim) { overlayScrim.hidden = false; requestAnimationFrame(() => overlayScrim.classList.add('is-open')); }
    document.body.classList.add('search-overlay-open');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  };
  const closeSearch = () => {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    if (overlayScrim) { overlayScrim.classList.remove('is-open'); setTimeout(() => { overlayScrim.hidden = true; }, 280); }
    document.body.classList.remove('search-overlay-open');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) closeSearch();
  });

  if (searchInput && resultsBox) {
    let debounce;
    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { resultsBox.innerHTML = ''; return; }
      debounce = setTimeout(() => runPredictive(q), 220);
    });
  }

  const runPredictive = async (q) => {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=4&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Suggest failed');
      const data = await res.json();
      renderPredictive(data.resources.results);
    } catch (err) { console.error(err); }
  };

  const renderPredictive = (results) => {
    if (!resultsBox) return;
    const groups = [];
    if (results.products && results.products.length) {
      groups.push(group('Patterns', results.products.map(p => hit(p, p.image, formatPrice(p.price)))));
    }
    if (results.collections && results.collections.length) {
      groups.push(group('Collections', results.collections.map(c => hit(c, null, ''))));
    }
    if (results.pages && results.pages.length) {
      groups.push(group('Pages', results.pages.map(p => hit(p, null, ''))));
    }
    if (results.articles && results.articles.length) {
      groups.push(group('Articles', results.articles.map(a => hit(a, a.image, ''))));
    }
    resultsBox.innerHTML = groups.length
      ? groups.join('')
      : '<p class="search-overlay__empty">No results yet — try another word.</p>';
  };

  const formatPrice = (priceStr) => {
    if (!priceStr) return '';
    return `$${Number(priceStr).toFixed(2)} AUD`;
  };
  const group = (title, hits) => `<section class="search-overlay__group"><h3>${title}</h3><ul class="search-overlay__list">${hits.join('')}</ul></section>`;
  const hit = (item, image, meta) => `<li><a class="search-overlay__hit" href="${item.url}">${image ? `<img src="${image}" alt="">` : ''}<span class="search-overlay__hit-body"><span class="search-overlay__hit-title">${item.title}</span>${meta ? `<span class="search-overlay__hit-meta">${meta}</span>` : ''}</span></a></li>`;
})();
